import { render } from "./ModalMsg.vue?vue&type=template&id=0148c462&scoped=true&ts=true"
import script from "./ModalMsg.vue?vue&type=script&lang=ts"
export * from "./ModalMsg.vue?vue&type=script&lang=ts"

import "./ModalMsg.vue?vue&type=style&index=0&id=0148c462&scoped=true&lang=css"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0148c462"]])

export default __exports__